if (Cookies.get('age_gate') != 'yes') {
  document.querySelector('#age-gate').classList.toggle('show');
  document.querySelector('.body').classList.toggle('age-gate');
} else {
  $(document).ready(function () {
    if (Cookies.get('cp_signup') != 'yes') {
      setTimeout(function () {
        document.querySelector('#signup-popup').classList.toggle('show');
      }, document.querySelector('#signup-popup').getAttribute("data-delay"));
    }
  });
}

if (Cookies.get('cp_signup') == 'yes') {
  document.querySelector('#signup-popup').remove();
}

$(document).ready(function () {
  $("#age-gate .accept").click(function (event) {
    Cookies.set('age_gate', 'yes', {
      expires: 7
    })
    document.querySelector('#age-gate').classList.toggle('hidden');
    document.querySelector('#age-gate').classList.toggle('show');
    document.querySelector('.body').classList.toggle('age-gate');;

    if (Cookies.get('cp_signup') != 'yes') {
      setTimeout(function () {
        document.querySelector('#signup-popup').classList.toggle('show');
      }, document.querySelector('#signup-popup').getAttribute("data-delay"));
    }

  });
});